import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getPresentationMode, messagesFor, subscribePresentation } from './presentation/runtime';

let savedLanguage = 'de';
try { savedLanguage = localStorage.getItem('goodvale_language') || 'de'; } catch { /* Private storage can be unavailable. */ }
i18n.use(initReactI18next).init({
  resources: Object.fromEntries(['de', 'en'].map(language => [language, { translation: messagesFor(getPresentationMode(), language) }])),
  lng: savedLanguage,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});
subscribePresentation(() => {
  for (const language of ['de', 'en']) {
    i18n.removeResourceBundle(language, 'translation');
    i18n.addResourceBundle(language, 'translation', messagesFor(getPresentationMode(), language));
  }
  // Presentation-aware translation hooks subscribe to the runtime without changing t identity.
});
export function changeLanguage(language) {
  i18n.changeLanguage(language);
  try { localStorage.setItem('goodvale_language', language); } catch { /* Keep session language. */ }
}
export default i18n;
